import axiosIns from "@/libs/axios";

export function requestLoadInventory(reqData) {
    return axiosIns.post("/admin/list_inventory", reqData, {});
}
